import { CanLoad, UrlSegment, Route, Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { RxBrowserDetectionService } from '../rx-browser-detection.service';
import { AuthService } from '@nrwl/rx-service-auth';

@Injectable({
  providedIn: 'root',
})
export class RxIELoadGuard implements CanLoad {
  constructor(
    private _browserDetection: RxBrowserDetectionService,
    private _router: Router,
    private _authService: AuthService,
  ) {}

  public canLoad(
    route: Route,
    segment: UrlSegment[],
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this._browserDetection.isIE) {
      return true;
    }

    this._authService.logout();
    return false;
  }
}
